module.exports = am4plugins_forceDirected;